import { TextInput } from "@mantine/core";
import { useEffect, useState, type ReactNode } from "react";

interface TextCellProps {
  value: string | undefined;
  updateValue: (value: string | null) => void;
  error?: ReactNode;
  placeholder?: string;
}

function TextCell({
  value,
  error,
  updateValue,
  placeholder = "Begründung eingeben"
}: TextCellProps) {
  const [localValue, setLocalValue] = useState<string | undefined>(value);

  useEffect(() => setLocalValue(value), [value]);

  function handleChange(newValue: string | undefined) {
    if (value !== newValue) {
      const updatedValue = typeof newValue !== "undefined" ? newValue : null;

      setLocalValue(updatedValue ?? undefined);
      updateValue(updatedValue);
    }
  }

  return (
    <div className="payments-text-cell">
      <TextInput
        error={error}
        placeholder={placeholder}
        type="text"
        value={localValue}
        onChange={(e) => handleChange(e.target.value)}
      />
    </div>
  );
}

export { TextCell };
